import { mapDate, mapDates } from 'App/resources/genericMapper';
import { parseDate, parseDates } from 'App/resources/genericParser';
import LZString from 'lz-string';
import history from 'App/pages/routes/history';
import findAll from 'App/babel/helpers/findAll';
import DataCache from 'App/babel/services/DataCache';
import AppService from 'App/legacy/AppService';
import CountryCodes from 'App/services/CountryCodes';

/*
	Tools compatibility shim (WEB-7604).

	The Angular run block in ui/app/upsales/common/services/tools.js populates window.Tools with
	Angular-DI services. This module is the standalone counterpart: it installs the entries that are
	backed by non-Angular modules, so legacy `Tools.*` callers keep working as services are extracted
	from Angular one by one.

	Boot order (see ui/index.html + ui/app/index.js):
	1. index.html creates `window.Tools = {}`
	2. installToolsShim() runs at the React entry, before Angular bootstraps
	3. Angular's tools.js overwrites any key it still registers — Angular stays the source of truth
	   for a service until its `window.Tools.X = ...` line is deleted from tools.js

	When a Phase 5 sub-issue (WEB-7605 AppService, WEB-7608 event bus, ...) extracts a service into a
	standalone module, add its entry here and delete the corresponding line from tools.js. Services
	whose callers are all converted to direct imports instead (like FeatureHelper, WEB-7606) never
	need an entry here. WEB-7616 deletes this file once no `Tools.*` references remain.
*/
// The Tools namespace declares its members as consts (read-only through typeof Tools), so entries
// are applied with Object.assign. `satisfies` still type-checks each entry against ui/types/Tools.d.ts.
const shimEntries = {
	mapDate,
	mapDates,
	parseDate,
	parseDates,
	LZString,
	routerHistory: history,
	DataCache,
	findAll,
	// WEB-8009: the standalone carries the full wrapper surface since WEB-7605. The Angular tree
	// still uses its DI AppService wrapper, which delegates to this same singleton/store.
	AppService,
	// WEB-7777: the Angular CountryCodes factory delegates to this same standalone.
	CountryCodes
} satisfies Partial<typeof window.Tools>;

const installToolsShim = () => {
	Object.assign(window.Tools, shimEntries);
};

export default installToolsShim;
